function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
export function parseJson(value, fallback) {
  if (!value) return fallback;
  if (_typeof(value) === 'object') return value;
  try {
    return JSON.parse(value);
  } catch (e) {
    return fallback;
  }
}
function pickValue(data, camelKey, snakeKey, fallback) {
  if (data[camelKey] !== undefined && data[camelKey] !== null) return data[camelKey];
  if (data[snakeKey] !== undefined && data[snakeKey] !== null) return data[snakeKey];
  return fallback;
}
export function normalizeThemeInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var type = arguments.length > 1 ? arguments[1] : undefined;
  var value = parseJson(data, data || {});
  if (type === 'category' && (typeof value === 'number' || typeof value === 'string')) {
    value = {
      status: Number(value) || 0
    };
  }
  if (!value || _typeof(value) !== 'object') return value;
  var configValue = parseJson(value.value, value.value || {});
  var normalized = _objectSpread(_objectSpread({}, value), {}, {
    value: configValue,
    theme_color: pickValue(value, 'themeColor', 'theme_color', value.theme_color),
    gradient_color: pickValue(value, 'gradientColor', 'gradient_color', value.gradient_color),
    sub_color: pickValue(value, 'subColor', 'sub_color', value.sub_color),
    light_color: pickValue(value, 'lightColor', 'light_color', value.light_color),
    is_show: pickValue(value, 'isShow', 'is_show', value.is_show),
    is_bg_color: pickValue(value, 'isBgColor', 'is_bg_color', value.is_bg_color),
    is_bg_pic: pickValue(value, 'isBgPic', 'is_bg_pic', value.is_bg_pic),
    color_picker: pickValue(value, 'colorPicker', 'color_picker', value.color_picker),
    bg_pic: pickValue(value, 'bgPic', 'bg_pic', value.bg_pic),
    cover_pic: pickValue(value, 'coverPic', 'cover_pic', value.cover_pic),
    bg_tab_val: pickValue(value, 'bgTabVal', 'bg_tab_val', value.bg_tab_val)
  });
  if (type === 'theme' && value.themeData) {
    return _objectSpread(_objectSpread({}, normalized), parseJson(value.themeData, {}));
  }
  return normalized;
}
export function normalizeTheme() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var themeData = parseJson(item.themeData, item.themeData || item.theme_data || {});
  return _objectSpread(_objectSpread({}, item), {}, {
    add_time: item.addTime || item.add_time || '',
    category_data_id: item.categoryDataId || item.category_data_id || 0,
    category_data_update_time: item.categoryDataUpdateTime || item.category_data_update_time || '',
    category_default_image: item.categoryDefaultImage || item.category_default_image || '',
    category_image: item.categoryImage || item.category_image || '',
    detail_data_id: item.detailDataId || item.detail_data_id || 0,
    detail_data_update_time: item.detailDataUpdateTime || item.detail_data_update_time || '',
    detail_default_image: item.detailDefaultImage || item.detail_default_image || '',
    detail_image: item.detailImage || item.detail_image || '',
    home_data_id: item.homeDataId || item.home_data_id || 0,
    home_data_update_time: item.homeDataUpdateTime || item.home_data_update_time || '',
    home_default_image: item.homeDefaultImage || item.home_default_image || '',
    home_image: item.homeImage || item.home_image || '',
    is_del: item.isDel || item.is_del || 0,
    is_use: item.isUse || item.is_use || 0,
    page_type: item.pageType || item.page_type || 'theme',
    theme_data: themeData,
    theme_data_id: item.themeDataId || item.theme_data_id || 0,
    theme_data_update_time: item.themeDataUpdateTime || item.theme_data_update_time || '',
    up_time: item.upTime || item.up_time || '',
    user_data_id: item.userDataId || item.user_data_id || 0,
    user_data_update_time: item.userDataUpdateTime || item.user_data_update_time || '',
    user_default_image: item.userDefaultImage || item.user_default_image || '',
    user_image: item.userImage || item.user_image || ''
  });
}
export function normalizeThemeList() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var list = Array.isArray(page.list) ? page.list.map(normalizeTheme) : [];
  var data = _objectSpread(_objectSpread({}, page), {}, {
    list: list,
    count: page.total || page.count || 0
  });
  return _objectSpread(_objectSpread({}, data), {}, {
    data: data
  });
}
export function normalizeUsingTheme() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var themeData = parseJson(data.themeData, data.themeData || data.theme_data || {});
  var dataInfo = parseJson(data.dataInfo, data.dataInfo || data.data_info || []);
  return _objectSpread(_objectSpread({}, normalizeTheme(data)), {}, {
    data_info: Array.isArray(dataInfo) ? dataInfo.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        update_time: item.updateTime || item.update_time || ''
      });
    }) : [],
    theme_data: themeData,
    confuse: data.confuse || false
  });
}
export function toThemeListParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    page: params.page,
    limit: params.limit,
    title: params.title,
    type: params.type,
    isUse: params.isUse,
    isDel: params.isDel,
    pageType: params.pageType || params.page_type
  };
}
export function normalizeThemeCategoryTree() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!Array.isArray(list)) return [];
  return list.map(function () {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var children = normalizeThemeCategoryTree(item.children || item.child || item.childList || []);
    var title = item.title || item.label || item.name || '';
    var value = item.value !== undefined && item.value !== null ? item.value : item.id;
    var normalized = _objectSpread(_objectSpread({}, item), {}, {
      id: item.id !== undefined && item.id !== null ? item.id : value,
      value: value,
      title: title,
      label: item.label || title,
      name: item.name || title,
      child: children.length ? children : undefined,
      children: children.length ? children : undefined
    });
    return normalized;
  });
}